import { Component, Input, OnInit } from '@angular/core';
import { DataService } from 'src/app/@core/services/data.service';

@Component({
  selector: 'app-editor-custom-component-benefits',
  templateUrl: 'benefits.component.html',
  styleUrls: ['./benefits.component.scss']
})
export class BenefitsComponent implements OnInit {
    @Input() item: any;

    data: any;

    constructor(public dataService: DataService) {

    }

    ngOnInit() {
      this.getData();
    }

    getData() {
      this.dataService.benefits().subscribe((res: any) => {
        this.data = res.data;
      });
    }
 
}
